import moment from 'moment'
import { generateUniqueKeyWithNoPrefix } from '../../../helpers'
import { GridRows } from '../../../helpers/gridValuesGenerator/gridValuesGenerator'
import { QuantityAssistantDataTableRow } from './quantityAssistantModal.model'

export const gridRowsToDataTableRows = (rows: GridRows[]): QuantityAssistantDataTableRow[] => {
  return rows.map(row => gridRowToDataTableRows(row))
}

export const gridRowToDataTableRows = (row: GridRows): QuantityAssistantDataTableRow => {
  return {
    tempId: generateUniqueKeyWithNoPrefix(),
    startDate: moment(row.startDate).toDate(),
    endDate: moment(row.endDate).toDate(),
    quantity: row.quantity ? +row.quantity : 0
  }
}
